export const breadcrumb = {
  title: 'Virtual PBX',

  number: {
    index: 'Nomor PBX'
  },

  media: {
    index: 'Media'
  },

  operator: {
    index: 'Operator'
  },

  group: {
    index: 'Kelompok',
    create: 'Tambah Kelompok',
    edit: 'Edit Kelompok'
  },

  contact: {
    index: 'Kontak',
    create: 'Tambah Kontak',
    edit: 'Edit Kontak'
  },

  'sip-account': {
    index: 'SIP akun',
    create: 'Tambah SIP akun'
  },

  'service-package': {
    index: 'Paket service'
  },

  'phone-list': {
    index: 'Daftar nomor',
    create: 'Tambah Daftar nomor',
    edit: 'Edit Daftar nomor'
  },

  'time-condition': {
    index: 'Jadwal waktu',
    create: ' Jadwal',
    edit: 'Edit Jadwal'
  },

  worksheet: {
    index: 'Perlihatkan routing',
    create: 'Tambah skema routing'
  },
  setting: {
    index: 'Setting PBX'
  }
};
